import React, { Component } from 'react';
import axios from 'axios';

import LabelledTextInput from './shared/LabelledTextInput';
import Heading from './shared/Heading';
import MainButton from './shared/MainButton';

export default class Profile extends Component {
  constructor(props) {
    super(props);

    this.state = {
      email: null,
      password: null,
      confirmPassword: null,
      name: null,
    };
  }

  componentDidMount() {
    this.refreshData();
  }

  refreshData = () => {
    const endpoint = '/api/profile';
    axios.get(endpoint)
      .then((res) => {
        if (res.status === 200 && res.data.user) {
          const {
            email,
            password,
            name,
          } = res.data.user;

          this.setState({
            email,
            password,
            confirmPassword: password,
            name: `${name.first} ${name.last}`,
          });
        }
      })
      .catch((err) => {
        console.log(err);
      });
  }

  /* eslint-disable-next-line */
  onTextChange = (name) => {
    return (e) => {
      this.setState({
        submitted: false,
        [name]: e.target.value,
      });
    };
  }

  /* eslint-disable-next-line */
  validate = (inputName) => {
    const {
      email,
      password,
      confirmPassword,
      name,
      submitted,
    } = this.state;

    if (!submitted) return null;

    if (inputName === 'email') {
      if (!email) return 'Email must be specified.';
      /* eslint-disable-next-line */
      const emailRegex = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      if (!emailRegex.test(email)) return 'Not a valid email format.';
    }

    if (inputName === 'password') {
      if (!password) return 'Password must be specified.';
      if (password.length < 4) return 'Password too short.';
      if (password !== confirmPassword) return 'Password and confirmation must be the same.';
    }

    if (inputName === 'name') {
      if (!name) return 'Must have a valid name';
    }

    return null;
  }

  onSubmit = (e) => {
    e.preventDefault();

    const {
      name,
      email,
      password,
    } = this.state;

    this.setState({
      submitted: true,
    }, () => {
      const errors = [
        this.validate('name'),
        this.validate('email'),
        this.validate('password'),
      ].filter(err => err);

      if (errors.length > 0) return;

      const endpoint = '/api/profile';
      axios.post(endpoint, {
        name,
        email,
        password,
      })
        .then((res) => {
          if (res.status === 200) {
            return alert('Saved!');
          }
          alert('Error occured when saving.');
        })
        .catch((err) => {
          alert('Error occured when saving.');
          console.log(err);
        });
    });
  }

  render() {
    const {
      name,
      email,
      password,
      confirmPassword,
      // errorMessage,
    } = this.state;

    return (
      <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
        <Heading style={{ marginBottom: 50 }}>Update Profile Settings</Heading>
        {/* {errorMessage ? (<ErrorMessage message={errorMessage} style={{ marginTop: -25, marginBottom: 25 }} />) : null} */}
        <LabelledTextInput
          type="text"
          placeHolder="NAME"
          name="name"
          value={name}
          onChange={this.onTextChange('name')}
          errorMessage={this.validate('name')}
          style={{ width: 500 }}
          inputWidth={500}
        />
        <LabelledTextInput
          type="text"
          placeHolder="EMAIL"
          name="email"
          value={email}
          onChange={this.onTextChange('email')}
          errorMessage={this.validate('email')}
          style={{ width: 500 }}
          inputWidth={500}
        />
        <LabelledTextInput
          type="password"
          placeHolder="PASSWORD"
          name="password"
          value={password}
          onChange={this.onTextChange('password')}
          errorMessage={this.validate('password')}
          style={{ width: 500 }}
          inputWidth={500}
        />
        <LabelledTextInput
          type="password"
          placeHolder="CONFIRM PASSWORD"
          name="password"
          value={confirmPassword}
          onChange={this.onTextChange('confirmPassword')}
          errorMessage={this.validate('password')}
          style={{ width: 500 }}
          inputWidth={500}
        />
        <MainButton
          style={{
            width: 522, height: 35, backgroundColor: '#7392ee', color: 'white', marginBottom: 20, border: '2px solid #7392ee',
          }}
          onClick={this.onSubmit}
        >
          SAVE CHANGES
        </MainButton>
        <MainButton
          style={{
            width: 522, height: 35, backgroundColor: 'white', color: '#7392ee', border: '2px solid #7392ee',
          }}
          onClick={() => {
            this.refreshData();
          }}
        >
          RESET CHANGES
        </MainButton>
      </div>
    );
  }
}




// WEBPACK FOOTER //
// ./client/Profile.js